import type {Builder} from '@wix/document-services-types'
import type {IVariableRepository} from './repository'
import type {IVariableDefaultsExtractor} from './defaults-extractor'
import type {IVariableStyleTransformer} from './style-transformer'

export interface IVariablesService {
    getStylesManifest(): Record<string, Builder.StyleItem>
}

export class VariablesService implements IVariablesService {
    constructor(
        private readonly variableRepository: IVariableRepository,
        private readonly variableStyleTransformer: IVariableStyleTransformer,
        private readonly variableDefaultsExtractor: IVariableDefaultsExtractor
    ) {}

    getStylesManifest(): Record<string, Builder.StyleItem> {
        const rawData = this.variableRepository.getRawVariablesData()

        if (!rawData?.variables || !Array.isArray(rawData.variables)) {
            return {}
        }

        const defaultValues = this.variableDefaultsExtractor.extractDefaults(rawData)

        return this.variableStyleTransformer.transformVariablesToStyles(rawData.variables, defaultValues)
    }
}
